import { prop } from 'ramda';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useFormatter } from '@core/js/hooks/useFormatter';
import { useAppSelector, useUserSelector } from '@core/js/store/hooks';
import { IDynamicBalanceInfo, IMoneyInfo } from '@core/js/hooks/socket/types';

import * as actions from '@core/js/hooks/user/store/actions';

export const useUpdateUserBalance = () => {
    const dispatch = useDispatch();
    const formatter = useFormatter();
    const lang = useUserSelector(prop('lang')); /* Lugano changes */
    const dynamicTags = useAppSelector(prop('dynamicTags')); /* Lugano changes */

    return useCallback((serverBalances: IDynamicBalanceInfo[]): void => {
        const balances = serverBalances.reduce((acc: Record<string, IMoneyInfo>, balance) => {
            acc[balance.balanceType] = balance.balance;

            return acc;
        }, {});
        const casinoGamingBalance = balances?.casino_gaming_balance || {};
        const { amount: totalAmount, currencyCode } = casinoGamingBalance;
        const formattedBalance = formatter.formatCurrency(totalAmount, { currencyCode }, lang); /* Lugano changes */

        /* Lugano changes */
        const delay: any = dynamicTags?.DTAG_BALANCE_UPDATE_DELAY;

        if (!isNaN(delay)) {
            setTimeout(() => {
                dispatch(actions.userSetAttributesAction({
                    balance: {
                        balances,
                        totalAmount,
                        formattedBalance
                    }
                }));
            }, delay);
        } else {
            dispatch(actions.userSetAttributesAction({
                balance: {
                    balances,
                    totalAmount,
                    formattedBalance
                }
            }));
        }
        /* Lugano changes */

    }, [dispatch, dynamicTags.DTAG_BALANCE_UPDATE_DELAY, formatter, lang]);
};
